export default theme => ({
  container: {
    height: '100vh',
    color: theme.palette.grey.contrastText,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      backgroundColor: theme.palette.grey.main,
      position: 'relative !important',
      height: 'auto',
    },
  },
  firstRow: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    maxWidth: 685,
    paddingTop: '10vh',
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(6),
      paddingTop: theme.spacing(6),
    },
  },
  h1: {
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 400,
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: 300,
    },
  },
  secondRow: {
    flexGrow: 100,
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 685,
    paddingBottom: '5vh',
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(6),
    },
  },
  overContainer: {
    height: '100vh',
    overflow: 'hidden',
    backgroundColor: theme.palette.grey.main,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  logo: {
    position: 'absolute',
    cursor: 'pointer',
    left: theme.spacing(2),
    top: theme.spacing(2),
    width: 60,
    [theme.breakpoints.up('sm')]: {
      left: theme.spacing(3),
      top: theme.spacing(3),
      width: 80,
    },
    [theme.breakpoints.up('md')]: {
      width: 90,
      left: theme.spacing(12),
      top: theme.spacing(8),
    },
    [theme.breakpoints.up('lg')]: {
      width: 115,
      left: theme.spacing(18),
      top: theme.spacing(12),
    },
  },
  polygone9: {
    fill: '#a51367',
    position: 'absolute',
    bottom: -20,
    right: '20%',
  },
  polygone12: {
    fill: '#ef7d00',
    position: 'absolute',
    top: -20,
    right: '30%',
  },
  polygone30: {
    fill: '#005ca9',
    position: 'absolute',
    top: 'calc(50% - 125px)',
    right: -150,
  },
  polygone31: {
    fill: '#19926e',
    position: 'absolute',
    top: 'calc(50% - 50px)',
    left: -150,
  },
  polygone32: {
    fill: '#00a3b4',
    position: 'absolute',
    top: '60%',
    right: 50,
  },
  polygone33: {
    fill: '#f29fc5',
    position: 'absolute',
    bottom: -15,
    left: 100,
  },
});
